import { Directive } from '@angular/core';

let count = 0;

@Directive({
  selector: '[libId]',
  standalone: true,
  exportAs: 'id',
})
export class IdDirective {
  readonly value = `pl-elem-${++count}`;
}
